// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-module--footer--1PC9u","title":"index-module--title--2Z4Zb","tags":"index-module--tags--1RiD8"};